<template>
  <div class="lang-toggle" :data-variant="variant">
    <button
      type="button"
      class="lang-toggle__btn"
      :class="{ 'is-active': $lang === 'ja' }"
      @click="set('ja')"
    >JA</button>
    <span class="lang-toggle__sep">|</span>
    <button
      type="button"
      class="lang-toggle__btn"
      :class="{ 'is-active': $lang === 'en' }"
      @click="set('en')"
    >EN</button>
  </div>
</template>

<script>
export default {
  name: 'LangToggle',
  props: {
    variant: {
      type: String,
      default: 'light'
    }
  },
  methods: {
    set (lang) {
      this.$setLang(lang);
    }
  }
};
</script>

<style scoped>
.lang-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  user-select: none;
}
.lang-toggle__btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  color: inherit;
  opacity: 0.55;
  font-weight: inherit;
  font-size: inherit;
  transition: opacity .15s ease-in-out;
}
.lang-toggle__btn:hover { opacity: 0.85; }
.lang-toggle__btn.is-active { opacity: 1; text-decoration: underline; }
.lang-toggle__sep { opacity: 0.4; }
.lang-toggle[data-variant='dark'] { color: #fff; }
.lang-toggle[data-variant='light'] { color: #1f1f1f; }
</style>



// WEBPACK FOOTER //
// src/components/viewer/LangToggle.vue